import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from 'sonner';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';

// Scroll to top and update page title on route change
const pageTitles = {
  '/': 'SAFE Standard AI',
  '/why-safe': 'SAFE Standard AI - Why SAFE',
  '/governance': 'SAFE Standard AI - Governance',
  '/labs': 'SAFE Standard AI - SAFE Labs',
  '/sail': 'SAFE Standard AI - SAIL',
  '/safescore': 'SAFE Standard AI - SAFEScore',
  '/council': 'SAFE Standard AI - Council',
  '/roadmap': 'SAFE Standard AI - Adoption Pathway',
  '/brand': 'SAFE Standard AI - Brand',
  '/press': 'SAFE Standard AI - Press',
  '/network': 'SAFE Standard AI - Global Authority',
  '/ecosystem': 'SAFE Standard AI - Global Authority',
  '/research': 'SAFE Standard AI - Research',
  '/demo': 'SAFE Standard AI - SAIL Demo',
  '/admin': 'SAFE Standard AI - Admin',
  '/support': 'SAFE Standard AI - Support the Standard',
  '/support/thank-you': 'SAFE Standard AI - Thank You',
  '/onboarding': 'SAFE Standard AI - Council Onboarding',
  '/directory': 'SAFE Standard AI - Directory',
  '/directory/submit': 'SAFE Standard AI - Submit a Listing',
  '/advisory': 'SAFE Standard AI - Strategic Advisory',
  '/safe-labs/verification-readiness': 'AI Verification Readiness Programme | SAFE Labs',
  '/partnership-hub': 'SAFE Founding Council — Partnership Hub',
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = pageTitles[pathname] || 'SAFE Standard AI';
  }, [pathname]);
  return null;
}

// Pages
import HomePage from './pages/HomePage';
import WhySafePage from './pages/WhySafePage';
import GovernancePage from './pages/GovernancePage';
import LabsPage from './pages/LabsPage';
import SailPage from './pages/SailPage';
import CouncilPage from './pages/CouncilPage';
import RoadmapPage from './pages/RoadmapPage';
import SAFEScorePage from './pages/SAFEScorePage';
import BrandPage from './pages/BrandPage';
import PressPage from './pages/PressPage';
import NetworkPage from './pages/NetworkPage';
import ResearchPage from './pages/ResearchPage';
import DemoPage from './pages/DemoPage';
import AdminPage from './pages/AdminPage';
import OpenLetterPage from './pages/OpenLetterPage';
import SupportPage from './pages/SupportPage';
import SupportThankYouPage from './pages/SupportThankYouPage';
import OnboardingPage from './pages/OnboardingPage';
import DirectoryPage from './pages/DirectoryPage';
import DirectorySubmitPage from './pages/DirectorySubmitPage';
import AdvisoryPage from './pages/AdvisoryPage';
import VerificationReadinessPage from './pages/VerificationReadinessPage';
import PartnershipHubPage from './pages/PartnershipHubPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminAuthCallback from './components/admin/AdminAuthCallback';

function AppRoutes() {
  const location = useLocation();
  // Emergent OAuth returns the session_id in the URL fragment. This must be read
  // from useLocation().hash during render, before any protected screen loads.
  if (location.hash?.includes('session_id=')) {
    return <AdminAuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/why-safe" element={<WhySafePage />} />
          <Route path="/ecosystem" element={<NetworkPage />} />
          <Route path="/governance" element={<GovernancePage />} />
          <Route path="/labs" element={<LabsPage />} />
          <Route path="/sail" element={<SailPage />} />
          <Route path="/safescore" element={<SAFEScorePage />} />
          <Route path="/council" element={<CouncilPage />} />
          <Route path="/roadmap" element={<RoadmapPage />} />
          <Route path="/brand" element={<BrandPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/network" element={<NetworkPage />} />
          <Route path="/research" element={<ResearchPage />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/open-letter" element={<OpenLetterPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/support/thank-you" element={<SupportThankYouPage />} />
          <Route path="/onboarding" element={<OnboardingPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/directory/submit" element={<DirectorySubmitPage />} />
          <Route path="/advisory" element={<AdvisoryPage />} />
          <Route path="/safe-labs/verification-readiness" element={<VerificationReadinessPage />} />
          <Route path="/partnership-hub" element={<PartnershipHubPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-slate-50">
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: '0',
            border: '1px solid #E2E8F0',
          },
        }}
      />
    </div>
  );
}

export default App;
